// import ScrollOut
/*import ScrollOut from "scroll-out";

// Fade Up Effect Animation on any item with the .fadeinup class
ScrollOut({
    //targets:'.home #full-width-page-wrapper .wp-block-columns',
    //targets:'.fadeinup',
    targets: '.home #full-width-page-wrapper .wp-block-column:has(hr), .home #full-width-page-wrapper .wp-block-columns .wp-block-column:first-child:has(ul)',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInUp');
        // force reflow
        void el.offsetWidth;
        // re-add the animated cl
        el.classList.add('animate__animated', 'animate__fadeInUp');
        //el.animate([{ opacity: 0 }, { opacity: 1 }], 1000);
    }
});
// Fade Right Effect Animation on any item with the .fadeinright class
ScrollOut({
    //targets:'.home #full-width-page-wrapper .wp-block-columns',
    //targets:'.fadeinright',
    targets: '.home #full-width-page-wrapper .wp-block-columns .wp-block-column:last-child:has(h2, .wp-block-buttons)',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInRight');
        // force reflow
        void el.offsetWidth;
        // re-add the animated cl
        el.classList.add('animate__animated', 'animate__fadeInRight');
    }
});*/
//
import Lightbox from './bs5-lightbox';

const options = {
    keyboard: true
};

document.querySelectorAll('[data-toggle="lightbox"]').forEach((el) => el.addEventListener('click', (e) => {
    e.preventDefault();
    const lightbox = new Lightbox(el, options);
    lightbox.show();
}));
//
// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const swiper = new Swiper('.swiper', {
    // Optional parameters
    //direction: 'vertical',
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
    slidesPerView: 1,
    breakpoints: {
        992: {
            slidesPerView: 2,
            spaceBetween: 24
        }
    },
    autoHeight: true, // Make slides equal height
    autoplay: {
        delay: 10000,
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});
//
// Back to Top Button
// Get the button
var mybutton = document.getElementById("btn-back-to-top");
// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction();
};
//
function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
    }
    else {
        mybutton.style.display = "none";
    }
}
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);
//
function backToTop() {
    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
}
//
jQuery(document).ready(function ($) {
    $('a[href^="#block-"]').on('click', function (e) {
        e.preventDefault();
        //
        var headerHeight = $('#wrapper-navbar').outerHeight();
        var link = $(this).attr('href');
        var linkOffset = $(link).offset().top - headerHeight;
        //
        $('html, body').animate({
            scrollTop: linkOffset
        }, 'slow');
    });
});